import React from "react";
import ModalFrame from "../../../../toolkit/modalFrame";
import { Button, Container, Row, Col, Table, Alert } from "reactstrap";
import { descargarReporteVentasProducto } from "../../../actions/products";
import { successNotification } from "../../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

interface ProductoEliminacionDetalle {
  tabla: string;
  ocurrencias: number;
  eliminable: boolean;
  razonNoEliminable?: string;
}

interface ProductoEliminacionResumen {
  productoId: number;
  nombreProducto: string;
  posibleEliminacion: boolean;
  totalRegistrosEliminables: number;
  totalRegistrosNoEliminables: number;
  tieneCargos: boolean;
  mensaje: string;
  detalles: ProductoEliminacionDetalle[];
}

interface Props {
  isOpen: boolean;
  resumen: ProductoEliminacionResumen | null;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

interface State {
  downloading: boolean;
}

class DeleteProductModal extends React.Component<Props, State> {
  state = {
    downloading: false
  };

  handleDownloadReport = () => {
    const { resumen } = this.props;
    this.setState({ downloading: true });

    if (resumen) {
      descargarReporteVentasProducto(resumen.productoId, (error: any) => {
        this.setState({ downloading: false });

        if (!error) {
          successNotification("Reporte descargado exitosamente");
        }
      });
    }
  };

  render() {
    const { isOpen, resumen, loading, onConfirm, onCancel } = this.props;
    const { downloading } = this.state;

    if (!resumen) {
      return null;
    }

    const tablesEliminables = resumen.detalles.filter(
      d => d.eliminable && d.ocurrencias > 0
    );
    const tablesNoEliminables = resumen.detalles.filter(
      d => !d.eliminable && d.ocurrencias > 0
    );

    return (
      <ModalFrame
        title={`Eliminar Producto: ${resumen.nombreProducto}`}
        isOpen={isOpen}
        toggle={onCancel}
        size="lg"
      >
        <Container className="p-3">
          <Alert color={resumen.posibleEliminacion ? "warning" : "danger"}>
            <h5>{resumen.mensaje}</h5>
          </Alert>

          {resumen.posibleEliminacion && tablesEliminables.length > 0 && (
            <div className="mb-4">
              <h6 className="text-success">
                <strong>
                  Registros que serán eliminados (
                  {resumen.totalRegistrosEliminables}):
                </strong>
              </h6>
              <Table size="sm" bordered>
                <thead>
                  <tr>
                    <th>Conceptos</th>
                    <th className="text-right">Registros</th>
                  </tr>
                </thead>
                <tbody>
                  {tablesEliminables.map((detalle, idx) => (
                    <tr key={idx}>
                      <td>{detalle.tabla}</td>
                      <td className="text-right">{detalle.ocurrencias}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {tablesNoEliminables.length > 0 && (
            <div className="mb-4">
              <h6 className="text-danger">
                <strong>
                  Registros que impiden la eliminación (
                  {resumen.totalRegistrosNoEliminables}):
                </strong>
              </h6>
              <Table size="sm" bordered>
                <thead>
                  <tr>
                    <th>Conceptos</th>
                    <th className="text-right">Registros</th>
                    <th>Razón</th>
                  </tr>
                </thead>
                <tbody>
                  {tablesNoEliminables.map((detalle, idx) => (
                    <tr key={idx}>
                      <td>{detalle.tabla}</td>
                      <td className="text-right">{detalle.ocurrencias}</td>
                      <td className="text-danger">
                        {detalle.razonNoEliminable}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          <Row>
            <Col>
              {resumen.tieneCargos && (
                <Button
                  color="info"
                  onClick={this.handleDownloadReport}
                  disabled={downloading}
                >
                  <FontAwesomeIcon icon={faDownload} />{" "}
                  {downloading ? "Descargando..." : "Reporte de Ventas"}
                </Button>
              )}
            </Col>
            <Col className="text-right">
              <Button color="secondary" onClick={onCancel} disabled={loading}>
                Cancelar
              </Button>
              {resumen.posibleEliminacion && (
                <Button
                  color="danger"
                  onClick={onConfirm}
                  disabled={loading}
                  className="ml-2"
                >
                  {loading ? "Eliminando..." : "Confirmar Eliminación"}
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default DeleteProductModal;
